import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Paper,
    TextField,
    Button,
    Typography,
    Alert,
} from '@mui/material';
import { useAuth } from 'context/AuthContext';

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
    },
    paper: {
        p: 4,
        width: '100%',
        maxWidth: 400,
        bgcolor: 'background.paper',
    },
    title: {
        mb: 3,
        textAlign: 'center',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    button: {
        mt: 2,
        py: 1.5,
    },
};

export default function LoginPage() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(username, password);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.error || '로그인에 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={styles.container}>
            <Paper sx={styles.paper} elevation={3}>
                <Typography variant="h1" sx={styles.title}>
                    Into Build System
                </Typography>

                <Box component="form" onSubmit={handleSubmit} sx={styles.form}>
                    <TextField
                        label="사용자명"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        fullWidth
                        autoFocus
                        size="small"
                    />
                    <TextField
                        label="비밀번호"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        fullWidth
                        size="small"
                    />

                    {error && (
                        <Alert severity="error" sx={{ mt: 1 }}>
                            {error}
                        </Alert>
                    )}

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={loading}
                        sx={styles.button}
                    >
                        {loading ? '로그인 중...' : '로그인'}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}
